import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "../../auth/authProvider";
import {
  ClaimHelper,
  StringHelper,
  TokenHelper,
} from "../../assets/utils/helpers";
import { Container, Row, Col, Button } from "reactstrap";
import { Image } from "react-bootstrap";

export const HomeDemo = () => {
  const auth = useContext(Auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (auth.isAuthenticated()) {
      const claim = TokenHelper.getClaims();
      const defaultPage = ClaimHelper.getClaimStringValue("landing_page");
      const redirectUrl = StringHelper.replacePlaceholders(defaultPage, claim);
      navigate(`/${redirectUrl}`);
    }
  }, [auth]);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);
  return (
    <div className="bg-light py-5">
      <Container className="mb-5">
        <Row>
          <Col md={6} className="text-center text-md-start mb-4 mb-md-0">
            <h2 className="fw-bold">A mobile app for community engagement</h2>
            <p>
              Connect with your city and stay informed about local resources,
              events, and initiatives.
            </p>
            <Button style={{ backgroundColor: "#162242" }}>
              Download the app
            </Button>
          </Col>
          <Col md={6}>
            <Image
              src="https://civic-bytes.vinformatix.com/svc/images/public/home.png"
              alt="Home"
              fluid
            />
          </Col>
        </Row>
      </Container>

      <Container className="mb-5 text-center">
        <h3 className="fw-bold mb-4">Stay connected with your community</h3>
        <p className="mb-4">
          here & now is your centralized hub to everything your city has to
          offer. The app aggregates information from many city websites,
          bringing resources and services to your fingertips.
        </p>
        <Row>
          <Col md={4}>
            <div className="mb-3 fs-3">
              <i className="bi bi-heart-fill"></i>
            </div>
            <h5 className="fw-bold">Find Local Resources</h5>
            <p>Browse a directory of community health and support services</p>
          </Col>
          <Col md={4}>
            <div className="mb-3 fs-3">
              <i className="bi bi-calendar-plus-fill"></i>
            </div>
            <h5 className="fw-bold">Stay Informed</h5>
            <p>Receive timely updates on local news and upcoming events</p>
          </Col>
          <Col md={4}>
            <div className="mb-3 fs-3">
              <i className="bi bi-lightbulb-fill"></i>
            </div>
            <h5 className="fw-bold">Submit ideas</h5>
            <p>Share suggestions to improve community development</p>
          </Col>
        </Row>
      </Container>

      <Container className="mb-5 text-center">
        <Row className="justify-content-center mb-3">
          <Col md={8}>
            <h2 className="fw-bold">
              Download the here & now app and get involved in your community!
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="auto">
            <Button style={{ backgroundColor: "#162242" }}>
              Download the app
            </Button>
          </Col>
        </Row>
      </Container>

      <Container className="mb-5">
        <Row>
          <Col md={6}>
            <h4 className="fw-bold">
              A civic engagement platform to connect cities with residents.
            </h4>
            <Button style={{ backgroundColor: "#008080" }} className="mt-3">
              Request Demo
            </Button>
          </Col>
          <Col md={6}>
            <Image
              src="https://civic-bytes.vinformatix.com/svc/images/public/home.png"
              alt="Home"
              fluid
            />
          </Col>
        </Row>
      </Container>

      <Container className="mb-5">
        <Row className="align-items-start">
          <Col md={6}>
            <h3 className="fw-bold mb-4">
              Powerful Tools for Local Governments
            </h3>
            <div className="d-flex flex-column gap-4">
              <Row className="align-items-start">
                <Col xs={1} className="text-center fs-5">
                  <i className="bi bi-journal-code"></i>
                </Col>
                <Col xs={11}>
                  <h5 className="fw-bold mb-1">Community Resources</h5>
                  <p className="mb-0">
                    Provides community-curated, relevant datasets.
                  </p>
                </Col>
              </Row>

              <Row className="align-items-start">
                <Col xs={1} className="text-center fs-5">
                  <i className="bi bi-chat-left-text-fill"></i>
                </Col>
                <Col xs={11}>
                  <h5 className="fw-bold mb-1">Polls & Feedback</h5>
                  <p className="mb-0">
                    Collect valuable reports and feedback insights.
                  </p>
                </Col>
              </Row>

              <Row className="align-items-start">
                <Col xs={1} className="text-center fs-5">
                  <i className="bi bi-person-square"></i>
                </Col>
                <Col xs={11}>
                  <h5 className="fw-bold mb-1">Community Development</h5>
                  <p className="mb-0">
                    Tools to improve and measure city outcomes.
                  </p>
                </Col>
              </Row>

              <Row className="align-items-start">
                <Col xs={1} className="text-center fs-5">
                  <i className="bi bi-bell-fill"></i>
                </Col>
                <Col xs={11}>
                  <h5 className="fw-bold mb-1">Notifications</h5>
                  <p className="mb-0">
                    Keep residents informed with important updates.
                  </p>
                </Col>
              </Row>
            </div>
          </Col>

          <Col md={6} className="mt-4 mt-md-0">
            <Image
              src="https://civic-bytes.vinformatix.com/svc/images/public/home.png"
              alt="Home"
              fluid
            />
          </Col>
        </Row>
      </Container>

      <Container className="mb-5">
        <Row className="align-items-start">
          <Col md={6} className="mb-4 mb-md-0">
            <Image
              src="https://civic-bytes.vinformatix.com/svc/images/public/home.png"
              alt="Home"
              fluid
            />
          </Col>

          <Col md={6}>
            <h3 className="fw-bold mb-4">Why Cities Love here & now</h3>
            <div className="d-flex flex-column gap-4">
              <Row className="align-items-start">
                <Col xs={1} className="text-center fs-5">
                  <i className="bi bi-play-btn-fill"></i>
                </Col>
                <Col xs={11}>
                  <h5 className="fw-bold mb-1">Centralized Hub</h5>
                  <p className="mb-0">
                    Helps better community-driven action titles.
                  </p>
                </Col>
              </Row>

              <Row className="align-items-start">
                <Col xs={1} className="text-center fs-5">
                  <i className="bi bi-person-square"></i>
                </Col>
                <Col xs={11}>
                  <h5 className="fw-bold mb-1">Resident Engagement</h5>
                  <p className="mb-0">
                    Enhances citizen engagement across the city.
                  </p>
                </Col>
              </Row>

              <Row className="align-items-start">
                <Col xs={1} className="text-center fs-5">
                  <i className="bi bi-file-bar-graph"></i>
                </Col>
                <Col xs={11}>
                  <h5 className="fw-bold mb-1">Informed Decisions</h5>
                  <p className="mb-0">
                    Identifies data insights for city improvements.
                  </p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
